import * as React from 'react'
import { useIntl } from 'react-intl'

import PriceDetails from 'tripPlanner/components/ItemOfferPrice/PriceDetails'

import BodyText from 'LuxKit/Typography/BodyText'
import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'

interface Props {
  /** If null, don't show price */
  price?: number
  luxPlusPrice?: number
  currencyCode: string
  priceLabel?: string
  isOfferAvailable: boolean
  discountPercent?: number
  discountDisplayType?: React.ComponentProps<
    typeof PriceDetails
  >['discountDisplayType']
  totalLabel?: string
}

export function PlannedItemPriceContent(props: Props) {
  const intl = useIntl()
  const {
    price,
    luxPlusPrice,
    priceLabel,
    discountPercent,
    currencyCode,
    isOfferAvailable,
    discountDisplayType,
    totalLabel,
  } = props

  const resolvedPriceLabel = priceLabel ?? intl.formatMessage({
    id: '5LshjPT2lwsXl5zOl7Ql',
    defaultMessage: 'From',
    description: 'Default price prefix label for planned items in the trip planner',
  })

  const showPrice = typeof price === 'number'

  const shouldShowDiscountPercent =
    !!discountPercent &&
    discountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE

  if (!isOfferAvailable) {
    return (
      <BodyText variant="large" weight="bold">
        {intl.formatMessage({
          id: 'J7dBW-9sOi4TdiC_D1rc',
          defaultMessage: 'Sold Out',
          description: 'Label shown when an offer is no longer available in the trip planner',
        })}
      </BodyText>
    )
  }

  if (!showPrice) {
    return null
  }

  return (
    <PriceDetails
      price={Math.ceil(price)}
      luxPlusPrice={luxPlusPrice ? Math.ceil(luxPlusPrice) : undefined}
      currencyCode={currencyCode}
      discount={
        shouldShowDiscountPercent ? Math.floor(discountPercent) : undefined
      }
      priceLabel={resolvedPriceLabel}
      discountDisplayType={discountDisplayType ?? 'badge'}
      totalLabel={totalLabel}
    />
  )
}
